"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { ArrowUpRight, Wallet } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Button } from "@/components/ui/button";
import { CHAT_CONTEXT_COOKIE } from "@/lib/constants";
import { useApi } from "@/lib/fetch-client";
import { formatCredits } from "@/lib/format-credits";
export function OrganizationCreditsNotice() {
  const $ = _c(21);
  const api = useApi();
  const pathname = usePathname();
  let t0;
  if ($[0] !== api) {
    t0 = api.queryOptions("get", "/orgs");
    $[0] = api;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data
  } = useQuery(t0);
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== data?.organizations || $[3] !== pathname) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const organizations = data?.organizations.filter(_temp);
      if (!organizations?.length) {
        t6 = null;
        break bb0;
      }
      t3 = "Available organization credits";
      t4 = "mb-8 rounded-2xl border border-lounge-gold/30 bg-lounge-gold/[0.06] p-5 sm:p-6";
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <div className="flex items-start gap-3"><Wallet className="mt-0.5 size-5 shrink-0 text-lounge-gold" /><div><h2 className="font-display text-xl font-semibold">You already have credits</h2><p className="mt-1 text-sm leading-relaxed text-muted-foreground">Your organization credits are separate from your Chat plan allowance. Switch to an organization below to use its balance in Lounge, without a membership.</p></div></div>;
        $[10] = t5;
      } else {
        t5 = $[10];
      }
      t1 = "mt-4 divide-y divide-border";
      let t7;
      if ($[11] !== pathname) {
        t7 = org_0 => <li key={org_0.id} className="flex flex-wrap items-center justify-between gap-3 py-3 last:pb-0"><div className="min-w-0"><p className="break-words text-sm font-medium">{org_0.name}</p><p className="text-sm text-muted-foreground"><span className="font-medium tabular-nums text-foreground">${formatCredits(Number(org_0.credits))}</span>{" "}in pay-as-you-go credits</p></div><Button asChild={true} variant="outline" size="sm"><Link href={`${pathname === "/pricing" ? "/" : pathname}?orgId=${encodeURIComponent(org_0.id)}`} onClick={_temp2} aria-label={`Use credits from ${org_0.name}`}>Use these credits <ArrowUpRight className="size-4" /></Link></Button></li>;
        $[11] = pathname;
        $[12] = t7;
      } else {
        t7 = $[12];
      }
      t2 = organizations.map(t7);
    }
    $[2] = data?.organizations;
    $[3] = pathname;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t2) {
    t7 = <ul className={t1}>{t2}</ul>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t7) {
    t8 = <section aria-label={t3} className={t4}>{t5}{t7}</section>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function _temp2() {
  document.cookie = `${CHAT_CONTEXT_COOKIE}=; path=/; max-age=0; samesite=lax`;
}
function _temp(org) {
  return org.kind === "default" && org.status === "active" && Number(org.credits) > 0;
}